import { http } from '@/api/http'
import type { Table } from '@/lib/pos-types'
import { normalizeTable, unwrapList } from '@/api/normalizers'

export const tablesApi = {
  list: async (): Promise<Table[]> => {
    const res = await http.get<unknown>('/tables')
    return unwrapList(res.data).map(normalizeTable)
  },
  create: async (payload: unknown): Promise<Table> => {
    const res = await http.post<unknown>('/tables', payload)
    return normalizeTable(res.data)
  },
  update: async (tableId: string, payload: unknown): Promise<Table> => {
    const res = await http.patch<unknown>(`/tables/${encodeURIComponent(tableId)}`, payload)
    return normalizeTable(res.data)
  },
  delete: async (tableId: string): Promise<void> => {
    await http.delete(`/tables/${encodeURIComponent(tableId)}`)
  },
  reservationUnlock: async (tableId: string, code: string): Promise<void> => {
    await http.post(`/tables/${encodeURIComponent(tableId)}/reservation-unlock`, { code })
  },
  unlock: async (tableId: string, code: string): Promise<void> => {
    await http.post(`/tables/${encodeURIComponent(tableId)}/unlock`, { code })
  },
  transfer: async (tableId: string, destinationTableId: string): Promise<void> => {
    await http.post(`/tables/${encodeURIComponent(tableId)}/transfer`, { destination_table_id: destinationTableId })
  },
}
